@import '../../../../../../../constants/spacing.module.less';
@import '../../../../../../../constants/screen-width-breakpoints.module.less';
@import '~style-sheet-helpers/core.less';

.card {
  overflow: hidden;
  padding: @space-0;
}

@media @mobile, @tablet {
  .columns-wrapper {
    flex-direction: column-reverse;
  }
}

.content-column {
  flex: 1;
  text-align: left;
  padding: @space-24;
  background-color: var(--white);
  justify-content: space-between;
}

.content-column-description {
  color: var(--grey-600);
  line-height: 1.5;
  display: inline;
}

.illustration {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--green-E5F6EE);
  padding: @space-16 @space-0;
}

.description-link {
  padding-left: @space-4;
  font-size: 15px;
}
